import { useState } from "react";
import { Button } from "@mui/material";
import { API_URL } from "../../utils/auth";
import axios from "axios";
import Auth from '../../utils/auth';
import { useParams } from "react-router-dom";

const UploadTranscript = ({ setTranscript, setIsUploaded, setShowUploadButton, setTranscriptId }) => {
    const [file, setFile] = useState(null);
    const [uploading, setUploading] = useState(false);
    const { clientId } = useParams();
    const workspaceId = Auth.getWorkspaceId();

    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];
        if (selectedFile) {
            setFile(selectedFile);
        }
    };

    const handleUpload = async () => {
        if (!file) {
            document.getElementById("file-input").click();
            return;
        }

        if (!clientId) {
            console.error("Client ID is required");
            return;
        }

        setUploading(true);
        const formData = new FormData();
        formData.append("file", file);
        formData.append("clientId", clientId);
        formData.append("workspaceId", workspaceId);

        try {
            const response = await axios.post(`${API_URL}/utils/transcript`, formData, {
                headers: { "Content-Type": "multipart/form-data" }
            });

            if (response.data) {
                console.log("Upload response:", response.data);

                if (setTranscript) {
                    console.log("Setting transcript in parent component");
                    setTranscript(response.data.document);
                }
                if (setTranscriptId) setTranscriptId(response.data.id);
                if (setIsUploaded) {
                    console.log("Setting isUploaded to true");
                    setIsUploaded(true); 
                }

                if (setShowUploadButton) {
                    console.log("Setting showUploadButton to false");
                    setShowUploadButton(false); 
                }
            }
        } catch (error) {
            console.error("Upload error:", error);
        }
        setUploading(false);
    };

    return (
        <div className="flex flex-col items-center" style={{ marginTop: "2rem", marginBottom: "2rem" }}>
            <input
                type="file"
                accept=".txt,.vtt,.docx,.pdf"
                onChange={handleFileChange}
                style={{ display: "none" }}
                id="file-input"
            />
            <Button
                variant="outlined"
                onClick={file ? handleUpload : () => document.getElementById("file-input").click()}
                disabled={uploading}
                sx={{ borderColor: "#D3C3FC", color: "#1F1534" }}
            >
                {uploading ? "Uploading..." : file ? "Upload Selected Transcript" : "Upload Transcript"}
            </Button>
            <p style={{
                fontSize: "0.7rem",
                color: "#1f1534a1",
                paddingLeft: "0.4rem",
                marginTop: "0.5rem",
            }}>supported file types: .txt, .vtt, .docx, .pdf</p>
        </div>
    );
};

export default UploadTranscript;